var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAnalyticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    width: 80,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 16,
    fill: "#F9AB00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 14,
    width: 14,
    height: 52,
    rx: 7,
    fill: "#FFFFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 30,
    width: 14,
    height: 36,
    rx: 7,
    fill: "#FFFFFF",
    opacity: 0.92
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 46,
    width: 14,
    height: 20,
    rx: 7,
    fill: "#FFFFFF",
    opacity: 0.84
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalyticsIcon);
export default __webpack_public_path__ + "static/media/googleAnalyticsIcon.083bfa7708aa6dfb4d597efd4088b996.svg";
export { ForwardRef as ReactComponent };